var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F8F9FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.9734 22.2067C30.9734 21.6032 30.9199 21.0303 30.8282 20.4727H22.1963V23.9178H27.1386C26.9171 25.0484 26.2678 26.0032 25.3053 26.6525V28.9442H28.2539C29.9803 27.3477 30.9734 24.9949 30.9734 22.2067Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.1959 31.1674C24.6709 31.1674 26.741 30.3424 28.2535 28.9444L25.3049 26.6528C24.4799 27.2028 23.4334 27.5389 22.1959 27.5389C19.8049 27.5389 17.7806 25.9271 17.0549 23.75H14.0146V26.1104C15.5195 29.1049 18.6133 31.1674 22.1959 31.1674Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.055 23.7506C16.864 23.2006 16.7647 22.6124 16.7647 22.0013C16.7647 21.3902 16.8717 20.802 17.055 20.252V17.8916H14.0147C13.3883 19.1291 13.0293 20.5194 13.0293 22.0013C13.0293 23.4833 13.3883 24.8735 14.0147 26.111L17.055 23.7506Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.1959 16.4625C23.548 16.4625 24.7549 16.9284 25.7098 17.8375L28.3223 15.225C26.741 13.743 24.6709 12.834 22.1959 12.834C18.6133 12.834 15.5195 14.8965 14.0146 17.8909L17.0549 20.2513C17.7806 18.0743 19.8049 16.4625 22.1959 16.4625Z",
    fill: "#EA4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.f195d3b4b26633393251468d7458cdc1.svg";
export { ForwardRef as ReactComponent };